import { Box } from '../Common/Box';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useContext } from 'react';
import { PaymentMethodEnum } from '@/types/common';
import { getPaymentMethodLogoUrl } from '@/utils/paymentMethods';

export const CreditCardBox = () => {
  const {
    paymentMethodSelected,
    actions: { setPaymentMethodSelected },
  } = useContext(CheckoutContext);

  return (
    <Box
      data-testid="payment-method-box-credit-card"
      isSelected={paymentMethodSelected === PaymentMethodEnum.CREDIT_CARD}
      onSelect={() => setPaymentMethodSelected(PaymentMethodEnum.CREDIT_CARD)}
    >
      <div className="flex flex-row items-center gap-2">
        <img
          data-testid="credit-card-icon"
          src={getPaymentMethodLogoUrl(PaymentMethodEnum.CREDIT_CARD)}
          alt="credit-card"
        />
        <div className="text-sm color-base-foreground">Card</div>
      </div>
    </Box>
  );
};
